<div class="tab-content">
    <div>
        <!-- Document upload-->
        <ecpl-document-explorer [uploaderConfig]="upConfig" [uploadedFiles]="uploadedFiles"
          (saveChanges)="saveUploaded($event)" (toogleEditDisplayMode)="toggleEditMode($event)"
          (showDocumentDialog)="showDocumentDailog()">
        </ecpl-document-explorer>
        <div class="action-btns-wrapper">
            <button class="btn btn-primary" type="button"
              [disabled]="loading || (newDocumentAdded?.length > 0) || isFileSeclected()" (click)="Approve()">
                <span translate>APPROVE </span>
            </button>
        </div>
    </div>
    <div class="saving-loader overlay" *ngIf="showSavingLoader">
        <div class="saving-loader-message text-center">
            <img src="/assets/icons/blocks.gif" alt="">
            <p translate>SAVING</p>
        </div>
    </div>
</div>
<div class="tab-content" *ngIf="!hasRights">
    <div class="row">
        <div class="col-sm-12">
            <div class="form-group">
                <label for="documents" class="col-form-label" translate>DOCUMENTS</label>
                <!-- Table starts -->
                <p-table #employee [value]="emp" dataKey="EmployeeId" [rows]="10" [paginator]="true" [pageLinks]="3"
                  [rowsPerPageOptions]="[5,10,20]" [style]="{'width':'50vw','min-width':'600px'}" expandableRows="true"
                  (onHeaderCheckboxToggle)="onTableHeaderCheckboxToggle()" [(selection)]="selectedEmployeesForApproval">
                    <!-- Caption -->
                    <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix">
                            <div class="filter-controls-wrapper mb-2" style="display:block">
                                <div class="row">
                                    <div class="col-sm-2">
                                        <label for="documentname" class="col-form-label" translate>SEARCH</label>
                                    </div>
                                    <div class="col-sm-10">
                                        <input type="text" pInputText
                                          (input)="filterResults($event.target.value)" style="width:100%">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <!-- Header -->
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 38px;">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th>
                            <th></th>
                            <th>{{'NAME' | translate}}</th>
                            <th>{{'STATUS' | translate}}</th>
                        </tr>
                        <tr>
                            <th></th>
                            <th></th>
                            <th>
                                <input pInputText type="text"
                                  (input)="employee.filter($any($event.target)?.value, 'EmployeeName', 'contains')"
                                  placeholder="" class="p-column-filter">
                            </th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <!-- Body Content -->
                    <ng-template pTemplate="body" let-emp let-expanded="expanded" let-i="rowIndex">
                        <tr>
                            <td style="width: 55px;">
                                <p-tableCheckbox id="selectedOrders" [value]="emp">
                                </p-tableCheckbox>
                            </td>
                            <td>
                                <a (click)="employee.toggleRow(emp);toggleClick(i)" *ngIf="emp.TotalDocuments > 0"
                                  class="btn btn-icon">
                                    <span class="icon ic-sm"
                                      [ngClass]="setCollapse(i) ? 'icon-expand-arrow' : 'icon-collapse-arrow'"
                                      aria-hidden="true"></span>
                                </a>
                            </td>
                            <td>
                                <span>{{emp.EmployeeName}}</span>
                            </td>
                            <td>
                                <span [style.color]="emp.Color">{{emp.ApprovedStatus}}</span>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="expandedrow" let-emp>
                        <tr>
                            <td colspan="4">
                                <div>
                                    <!-- Table starts -->
                                    <p-table [value]="emp.ControlDocuments" [rows]="5"
                                      [style]="{'width':'100%','table-layout':'fixed'}">
                                        <!-- Header -->
                                        <ng-template pTemplate="header">
                        <tr>
                            <th style="width:40%">{{'DOCUMENT_NAME' | translate}}</th>
                            <th style="width:25%">{{'DATE_APPROVE' | translate}}</th>
                            <th style="width:25%">{{'UPLOADED_BY' | translate}}</th>
                            <th style="width:10%"></th>
                        </tr>
                    </ng-template>
                    <!-- Body Content -->
                    <ng-template pTemplate="body" let-emps>
                        <tr>
                            <td style="max-width:0;overflow:hidden">
                                <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis"
                                  pTooltip="{{emps.Filename}}" tooltipPosition="top">
                                    {{emps.Filename}}
                                </div>
                            </td>
                            <td>
                                <span>{{emps.ApprovedOn | date:'dd/MM/yyyy' }}</span>
                            </td>
                            <td style="max-width:0;overflow:hidden">
                                <div style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis"
                                  pTooltip="{{emps.CreatedBy}}" tooltipPosition="top">
                                    {{emps.CreatedBy}}
                                </div>
                            </td>
                            <td class="col-button">
                                <button (click)="deleteDoc(emps.Id)" type="button" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
                            </td>
                        </tr>
                    </ng-template>
                    <!-- Empty message -->
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="4">
                                {{'NO_RECORDS_FOUND'|translate}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <!-- Table ends -->
            </div>
            </td>
            </tr>
            </ng-template>
            <!-- Empty message -->
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td colspan="4">
                        {{'NO_RECORDS_FOUND'|translate}}
                    </td>
                </tr>
            </ng-template>
            </p-table>
            <!-- Table ends -->
        </div>
    </div>
</div>


<div class="row">
    <div class="col-sm-12">
        <div class="form-group position-relative">
            <button *ngIf="manualSelected" class="btn btn-outline-success" (click)="showDocumentDailog()">
                <span translate>ADD_FROM_MANUAL</span>
            </button>
            <button class="btn btn-outline-success" (click)="showAddDocumentDailog()">
                <span translate>ADD_FROM_DOCUMENTS</span>
            </button>
            <ecpl-document-explorer [uploaderConfig]="upConfigApp" [uploadedFiles]="uploadedFilesGrid"
              (saveChanges)="saveUploaded($event)">
            </ecpl-document-explorer>
        </div>
    </div>
</div>
<div class="action-btns-wrapper">
    <button class="btn btn-primary" [ngClass]="{'loading' : loading}"
      [disabled]="loading || (newDocumentAdded?.length <= 0 && selectedArticles?.length <=0) || selectedEmployeesForApproval?.length <= 0 "
      type="button" (click)="saveDoc()">
        <span translate>SAVE</span>
    </button>
</div>
</div>


<p-dialog header="{{'UPLOAD'| translate}}" [(visible)]="ShowPopUp" [modal]="true" 
  overflow="inherit" [style]="{width: '500px', height:'480px'}" [resizable]="false" [draggable]="false">
    <div style="margin: 0 0 10px 0;">
        <label for="appPerson">
            <span translate>SELECT_MANUAL</span>
            <span class="required">*</span>
        </label>
        <div>
            <p-select [(ngModel)]="selectedManual" (ngModelChange)="SelectManual($event)" [options]="manualList"
              placeholder="{{'SELECT_A_MANUAL'|translate}}" filter="true" [style]="{'width':'100%'}"> </p-select>
        </div>
    </div>
    <div *ngIf="dropDownAlinement" style="height: 315px;"></div>
    <div style="overflow: scroll; overflow-x: auto; max-height:300px" class="mbtm-10" *ngIf="showArchiveDocumentDailog">
        <app-ecpl-document-tree *ngIf="treeNode" treeId="adminManualsTree" [(ecplTreeData)]="treeNode"
          [(ecplActiveNode)]="treeActiveNode" [(ecplTreeCheckbox)]="addManualsEdit" [addFromManuals]="true"
          (ecplNodeEvent)="catchEvent($event)" [(ecplApiResponse)]="apiResponse">
        </app-ecpl-document-tree>
        <br />
    </div>
    <button [disabled]="selectedManual == null || selectingManual || !hasCheckedFiles()" class="btn btn-primary" type="button"
      (click)="addArticlesToPrivateDocs()">
        <span translate>ADD</span>
    </button>
</p-dialog>


<p-dialog header="{{'UPLOAD'| translate}}" [(visible)]="ShowDocumentPopUp" [modal]="true"
  overflow="inherit" [style]="{width: '500px', height:'480px'}" [resizable]="false" [draggable]="false">
    <div style="margin: 0 0 10px 0;">
        <label for="appPerson">
            <span translate>SELECT_DOCUMNETS</span>
            <span class="required">*</span>
        </label>

    </div>
    <div style="overflow: scroll; overflow-x: auto; max-height:300px" class="mbtm-10" *ngIf="showArchiveDocumentDailog">
        <app-ecpl-document-tree *ngIf="treeNode" treeId="adminManualsTree" [(ecplTreeData)]="treeNode"
          [(ecplActiveNode)]="treeActiveNode" [(ecplTreeCheckbox)]="addManualsEdit" [addFromManuals]="true"
          (ecplNodeEvent)="catchEvent($event)" [(ecplApiResponse)]="apiResponse">
        </app-ecpl-document-tree>
        <br />
    </div>
    <button [disabled]="!showArchiveDocumentDailog || !hasCheckedFiles()" class="btn btn-primary" type="button"
      (click)="addArticlesToPrivateDocs()">
        <span translate>ADD</span>
    </button>
</p-dialog>

<kuba-busy [busy]="loading" message="PROCESSING"></kuba-busy>
